import { Main, MainBody, MainTop, MainTopTitle, WhiteBox } from '@/components/Layout'
import React, { useState } from 'react'
import { TabContent, TabNavItems, TabPane } from '@/components/tabs'
import { BlacklistReportGrid } from '@/internal-app/pages/blacklistReports/blacklistReportGrid'
import context from '@/context'
import { BlacklistReportGridBankState } from '@/internal-app/pages/blacklistReports/blacklistReportGridBankState'
import { BlacklistReportGridCompanyType } from '@/internal-app/pages/blacklistReports/blacklistReportGridCompanyType'
import Resx from '@/components/Resx'
import { useLocalization } from '@/hooks/localization'

const BlacklistReports = (props) => {
  const [activeTab, setActiveTab] = useState('1')
  const { localize } = useLocalization()

  return <Main path={[{ text: 'BlacklistReports' }]}>
    <MainTop>
      <MainTopTitle>
        <Resx name='Reporting.BlacklistReports' />
      </MainTopTitle>
    </MainTop>
    <MainBody transparent>
      <WhiteBox>
        <TabNavItems
          buttonView
          activeTabId={activeTab}
          onClick={setActiveTab}
          items={[
            { id: '1', text: 'Blacklists.CbiBanks' },
            { id: '2', text: 'Blacklists.FederalBanks' },
            { id: '3', text: 'Blacklists.CbiCompanies' },
            { id: '4', text: 'Blacklists.FederalCompanies' },
            { id: '5', text: 'Blacklists.MasterListBanks' },
            { id: '6', text: 'Blacklists.MasterListCompanies' }
          ]} />

        <TabContent activeTab={activeTab} renderActiveOnly>
          <TabPane tabId='1'>
            <BlacklistReportGrid dataSource={context.api.blacklistReportService.getCbiBanks} sheetHeader={localize('Blacklists.CbiBanks')} />
          </TabPane>
          <TabPane tabId='2'>
            <BlacklistReportGrid dataSource={context.api.blacklistReportService.getFederalBanks} sheetHeader={localize('Blacklists.FederalBanks')} />
          </TabPane>
          <TabPane tabId='3'>
            <BlacklistReportGrid dataSource={context.api.blacklistReportService.getCbiCompanies} sheetHeader={localize('Blacklists.CbiCompanies')} />
          </TabPane>
          <TabPane tabId='4'>
            <BlacklistReportGrid dataSource={context.api.blacklistReportService.getFederalCompanies} sheetHeader={localize('Blacklists.FederalCompanies')} />
          </TabPane>
          <TabPane tabId='5'>
            <BlacklistReportGridBankState dataSource={context.api.blacklistReportService.getMasterListBanks} sheetHeader={localize('Blacklists.MasterListBanks')} />
          </TabPane>
          <TabPane tabId='6'>
            <BlacklistReportGridCompanyType dataSource={context.api.blacklistReportService.getMasterListCompanies} sheetHeader={localize('Blacklists.MasterListCompanies')} />
          </TabPane>
        </TabContent>
      </WhiteBox>
    </MainBody>
  </Main>
}

export { BlacklistReports }



// WEBPACK FOOTER //
// ./src/internal-app/pages/blacklistReports/index.js